module.exports = __webpack_public_path__ + "static/media/ken-anderson.b2179325.jpg";